'use strict';

var FirebaseObject = require('./FirebaseObject');
var KayleeBase = require('./KayleeBase');
var KayleeCache = require('./KayleeCache');

var KayleeEquipmentStates = {
    fromJson: fromJson,
    getEquipmentStates: getEquipmentStates,
};

function fromJson(data) {
    var reqProps = [ '$id' ];
    return FirebaseObject.$fromJson(data, 'EquipmentStates', reqProps, reqProps,
        function(data) { return getEquipmentStates(data.$id); }
    );
}

function getEquipmentStates(equipmentId) {
    var key = 'EquipmentStates: ' + equipmentId;
    var equipmentStates = KayleeCache.get(key);

    if (equipmentStates === null) {
        equipmentStates = new EquipmentStates(equipmentId);
        KayleeCache.put(key, equipmentStates);
    }

    return equipmentStates;
}

function EquipmentStates(equipmentId) {
    this.$nodeType = 'equipmentStates';
    var path = 'equipmentStates/' + equipmentId;

    FirebaseObject.call(this, KayleeBase.app.database().ref(path));
}

EquipmentStates.prototype = Object.create(FirebaseObject.prototype);
EquipmentStates.prototype.constructor = EquipmentStates;

EquipmentStates.prototype.$toJson = function() {
    return FirebaseObject.prototype.$toJson.call(this, [ '$id' ]);
};

EquipmentStates.prototype.toString = function() {
    return '[EquipmentStates (' + this.$id + ')]';
};

module.exports = KayleeEquipmentStates;
